// extracted by mini-css-extract-plugin
module.exports = {"row":"PhysicalStrength_row__sQOAO"};